/* eslint-disable max-len */
import { IconProps } from 'models/icons';
import React from 'react';

const Warning: React.FC<IconProps> = ({ color, ...props }) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.16427 4.20627C8.40671 1.99782 11.5876 1.99813 12.8303 4.20627L17.5549 12.6067C18.7735 14.7731 17.2084 17.4503 14.7229 17.4504H5.2717C2.78645 17.4499 1.22115 14.7729 2.43967 12.6067L7.16427 4.20627ZM11.5227 4.94163C10.8534 3.75304 9.14089 3.75273 8.47189 4.94163L3.74631 13.342C3.09024 14.5084 3.93369 15.9499 5.2717 15.9504H14.7229C16.0612 15.9503 16.9044 14.5085 16.2483 13.342L11.5227 4.94163ZM10.0012 12.9709C10.5533 12.9712 11.0012 13.4188 11.0012 13.9709C11.0012 14.5231 10.5533 14.9707 10.0012 14.9709C9.4489 14.9709 9.00119 14.5232 9.00119 13.9709C9.00121 13.4187 9.44892 12.9709 10.0012 12.9709ZM10.0012 6.22092C10.4152 6.22116 10.7512 6.55687 10.7512 6.97092V10.9709C10.7512 11.385 10.4152 11.7207 10.0012 11.7209C9.58698 11.7209 9.25119 11.3851 9.25119 10.9709V6.97092C9.25121 6.55673 9.58699 6.22092 10.0012 6.22092Z"
      fill={color ?? props?.style?.color}
    />
  </svg>
); 

export default Warning;
